import React, { Component } from "react";
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { style } from "@mui/system";
import swal from "sweetalert";

import OrdersReportService from "../../services/ordersreport.service";

export default class AddRefund extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderid: props.orderid,
            rerender: false,
            amountalreadyrefunded: 0,
            items: props.items,
            chosenitems: [],
            refundType: "",
            refundamount:'',
            handlingAgentName: "",
            refundStatus: "Pending",
            refundReason: "",
            explaination: "",
            customerbankdetails: false,
            bankName: "",
            accountowner: "",
            accountNumber: "",
            addrefuntbtntext: 'Add Refund',
            disableaddrefundbtn: false,
            user: props.user
        }
    }

    openPopup = (e) => {
        this.setState({
            isopen: true
        });
    }

    addRefund = (e) => {

        this.setState({
            addrefuntbtntext: 'Adding Refund...',
            disableaddrefundbtn: true
        });
        e.preventDefault();
        OrdersReportService.createRefund(this.state.orderid, this.state.chosenitems, this.state.refundType, this.state.refundamount, this.state.handlingAgentName, this.state.refundReason, this.state.explaination, this.state.customerbankdetails, this.state.bankName, this.state.accountowner, this.state.accountNumber, this.state.user.user_nicename)
        .then(response => {
            console.log('Refund response', {response});
            this.setState({
                addrefuntbtntext: 'Add Refund',
                disableaddrefundbtn: false,
                isopen: false
            });
            this.props.onChange();
            swal('Refund Added', "The refund has been submitted", "success");
        })
        .catch(err => console.log({err}));
    }

    showHideBankDetails = (e) => {
        if(!this.state.customerbankdetails) {
            this.setState({
                bankName: "",
                accountowner: "",
                accountNumber: "",
            });
        }
        this.setState({
            customerbankdetails: !this.state.customerbankdetails
        });
    }

    setChosenItems = (e) => {

        var chosenItems = Array.from(e.target.selectedOptions, option => option.value);
        console.log({chosenItems});
        this.setState({chosenitems: chosenItems});
    }

    render() {
        const style = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
        };
        return (
            <>
            <button type="button" className="btn" onClick={e => this.openPopup(e)}>Refund / Credit</button>
            <Modal
                open={this.state.isopen}
                onClose={e => {this.setState({isopen: false})}}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={{...style, width: 800, textAlign: 'center' }}>
                <form onSubmit={(e) => this.addRefund(e)} style={{textAlign: "left"}}>
                    <div className="row">
                        <div className="col supplier-confirm-phone-heading">
                            Add Refund
                        </div>
                    </div>
                     <div className="form-group row">
                        <label for="chosenitems" className="col-4 col-form-label"><b>Choose Products</b></label>
                        <div className="col-8">
                            <select className="form-control" multiple onChange={e => this.setChosenItems(e)} id="chosenitems" required="required" value={this.state.chosenitems}>
                                {this.state.items.length>0 && this.state.items.map((item, index)=>(
                                    <option key={index} value={item.id+"|"+item.name}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="form-group row" style={{marginBottom: "20px"}}>
                        <label for="refundType" className="col-4 col-form-label"><b>Choose Refund / Credit</b></label>
                        <div className="col-8"> 
                            <select className="form-control" id="refundType" required="required" onChange={e => {this.setState({refundType: e.target.value})}} value={this.state.refundType} >
                                <option value="">Choose Refund Type</option>
                                <option value="Refund">Refund</option>
                                <option value="Credit">Credit</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row" style={{marginBottom: "20px"}}>
                        <label for="refundamount" className="col-4 col-form-label"><b>Refund / Credit Amount</b></label>
                        <div className="col-8"> 
                            <input type="number" className="form-control" id="refundamount" placeholder="Enter refund amount" required="required" onChange={e => {this.setState({refundamount: e.target.value})}} value={this.state.refundamount} />
                        </div>
                    </div>
                    <div className="form-group row" style={{marginBottom: "20px"}}>
                        <label for="handlingAgentName" className="col-4 col-form-label"><b>Handling Agent Name</b></label>
                        <div className="col-8"> 
                            <input type="text" className="form-control" id="handlingAgentName" placeholder="Enter handling agent name" required="required" onChange={e => {this.setState({handlingAgentName: e.target.value})}} value={this.state.handlingAgentName} />
                        </div>
                    </div>
                    <div className="form-group row" style={{marginBottom: "20px"}}>
                        <label for="refundReason" className="col-4 col-form-label"><b>Refund Reason</b></label>
                        <div className="col-8"> 
                            <select className="form-control" id="refundReason" required="required" onChange={e => {this.setState({refundReason: e.target.value})}} value={this.state.refundReason} >
                                <option value="">Choose Refund Reason</option>
                                <option value="No Availablity">No Availablity</option>
                                <option value="Customer Cancelled">Customer Cancelled</option>
                                <option value="Bad Weather">Bad Weather</option>
                                <option value="Cancelled by Supplier">Cancelled by Supplier</option>
                                <option value="Complaint">Complaint</option>
                                <option value="Others">Others</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row" style={{marginBottom: "20px"}}>
                        <label for="explaination" className="col-4 col-form-label"><b>Explanation & Comments</b></label>
                        <div className="col-8"> 
                            <textarea rows="4" className="form-control" id="explaination" placeholder="Enter explaination" required="required" onChange={e => {this.setState({explaination: e.target.value})}} value={this.state.explaination}></textarea>
                        </div>
                    </div>

                    <div className="form-group row" style={{marginBottom: "20px"}}>
                        <label for="bankdetails" style={{backgroundColor: "bisque", cursor: "pointer"}} className="col-12 col-form-label" onClick={e => this.showHideBankDetails(e)}><b>Customer Bank Details</b></label>
                    </div>
                    {this.state.customerbankdetails==true &&
                        <>
                        <div className="form-group row" style={{marginBottom: "20px"}}>
                            <label for="bankName" className="col-4 col-form-label"><b>Bank Name</b></label>
                            <div className="col-8"> 
                                <input type="text" className="form-control" id="bankName" placeholder="Enter bank name" required="required" onChange={e => {this.setState({bankName: e.target.value})}} value={this.state.bankName} />
                            </div>
                        </div>

                        <div className="form-group row" style={{marginBottom: "20px"}}>
                            <label for="handlingAgentName" className="col-4 col-form-label"><b>Name of Account Owner</b></label>
                            <div className="col-8"> 
                                <input type="text" className="form-control" id="accountowner" placeholder="Enter account owner name" required="required" onChange={e => {this.setState({accountowner: e.target.value})}} value={this.state.accountowner} />
                            </div>
                        </div>
                        
                        <div className="form-group row" style={{marginBottom: "20px"}}>
                            <label for="accountNumber" className="col-4 col-form-label"><b>Account Number</b></label>
                            <div className="col-8"> 
                                <input type="text" className="form-control" id="accountNumber" placeholder="Enter account number" required="required" onChange={e => {this.setState({accountNumber: e.target.value})}} value={this.state.accountNumber} />
                            </div>
                        </div>
                        </>
                    }

                    <div style={{display: "flex", justifyContent: "space-between", marginTop: "40px"}}>
                        <button type="submit" className="btn btn-sm btn-success bg-green-800" style={{marginRight: "20px"}} disabled={this.state.disableaddrefundbtn}>{this.state.addrefuntbtntext}</button><button type="button" className="btn btn-sm btn-danger bg-red-500" onClick={e => {this.setState({isopen: false})}}>Close</button>
                    </div>
                </form>
                </Box>
            </Modal>
            </>
        );
    }
}